import * as React from 'react';
import { TableMapper } from '../shared';
import { useTableWrapping } from '../../context';
import { groupNamesByWrapping } from '../../context/wrapping/constants';
export var TableBodyMapper = function () {
    var wrapping = useTableWrapping();
    return (React.createElement(TableMapper, { rampName: "Body".concat(groupNamesByWrapping[wrapping], "Base") }));
};
